export function durationColor(minutes) {
  const m = parseFloat(minutes) || 0;
  if (m < 10) return { bg: 'bg-emerald-500/10', text: 'text-emerald-600', border: 'border-emerald-200', label: 'Quick' };
  if (m <= 30) return { bg: 'bg-sky-500/10', text: 'text-sky-600', border: 'border-sky-200', label: 'Standard' };
  return { bg: 'bg-violet-500/10', text: 'text-violet-600', border: 'border-violet-200', label: 'Deep Dive' };
}

export function difficultyColor(level) {
  const d = (level || '').toLowerCase();
  if (d === 'beginner') return { bg: 'bg-emerald-500/10', text: 'text-emerald-600', border: 'border-emerald-200' };
  if (d === 'intermediate') return { bg: 'bg-amber-500/10', text: 'text-amber-600', border: 'border-amber-200' };
  if (d === 'advanced') return { bg: 'bg-rose-500/10', text: 'text-rose-600', border: 'border-rose-200' };
  return { bg: 'bg-muted', text: 'text-muted-foreground', border: 'border-border' };
}
